import { AppData, BookingData } from "../../AppDataProvider";
import { CompletePaymentStepPayload } from "../../actions";
import { emitBookingCreatedEvent } from "../../../utils/emitEvent/emitBookingCreatedEvent";
import { Mixpanel } from "../../../mixpanel";
import { PartRequired } from "../../../utils/types";

export type CompletePaymentsStepOpts = {
  appData: AppData;
  payload: CompletePaymentStepPayload;
};

type CompletePaymentStepBookingData = PartRequired<BookingData, "organisation">;

export const completePaymentsStep = (
  options: CompletePaymentsStepOpts,
): AppData => {
  Mixpanel.track({ name: "Completed step", props: { step: "payments" } });

  const { bookingData } = options.appData;

  const updatedBookingData = {
    ...bookingData,
    ...options.payload.updatedData,
  } as CompletePaymentStepBookingData;

  const updatedAppData: AppData = {
    ...options.appData,
    bookingData: updatedBookingData,
    currentStep: "bookingCreated",
  };

  emitBookingCreatedEvent(updatedAppData);

  return updatedAppData;
};
